export default __webpack_public_path__ + "static/media/com_banking.1c4e278b.png";